<template>
  <WithTitle :title="$t('tab.equipment')">
    <ProductEquipments />
  </WithTitle>
</template>

<script>
import WithTitle from '../layouts/WithTitle'
import ProductEquipments from '../../../components/product/product-page/ProductEquipments'

export default {
  name: 'ProductEquipment',
  components: {
    ProductEquipments,
    WithTitle
  }
}
</script>

<style scoped>

</style>
